import dayjs from "dayjs";
import * as mask from "inputmask";
import _ from "lodash";
import React from "react";
import { Avatar, Popover, Whisper } from "rsuite";
import { MethodsUtils } from "../../core/utils/MethodsUtils";

interface SchemaToParsedCellProps {
  row: any;
  field: any;
}

export class SchemaToParsedCell extends React.Component<
  SchemaToParsedCellProps,
  {}
> {
  parseMask(value: string | object | number) {
    if (typeof value === "string") {
      if (value.length) {
        return mask.default.format(value, { mask: this.props.field.mask });
      } else {
        return null;
      }
    }
    return value;
  }

  static parseFieldToValue = (field: any, row: any, html: boolean = false) => {
    var value = row[field.name];

    var resultadoOutput = null;

    if (field.type === "file" && field.name === "product_file") {
      resultadoOutput = (
        <>
          {value?.map((item: any) => {
            return (
              <Whisper
                trigger="hover"
                delayClose={0}
                placement="auto"
                speaker={
                  <Popover>
                    <img width={300} height={300} src={item?.file_path}></img>
                  </Popover>
                }
              >
                <Avatar style={{ marginRight: 5 }} circle>
                  <img width={50} height={50} src={item?.file_path}></img>
                </Avatar>
              </Whisper>
            );
          })}
        </>
      );
    } else if (field.type === "checkbox") {
      if (html) {
        resultadoOutput = value ? (
          <div>
            <i className="fas fa-fw fa-check text-success"></i> Sim
          </div>
        ) : (
          <div>
            <i className="fas fa-fw fa-times text-danger"></i> Não
          </div>
        );
      } else {
        resultadoOutput = value ? "Sim" : "Não";
      }
    } else if (field.type === "grid") {
      resultadoOutput = (value ? value.length : 0) + " Itens";
    } else if (field.type === "select") {
      if (field.options && _.isArray(field.options)) {
        if (value) {
          var foundValue: any = _.first(
            field.options.filter((item: any) => {
              if (value !== null && value !== undefined) {
                return item.value === value.toString();
              }
              return undefined;
            })
          );
          resultadoOutput = (foundValue?.label ?? value)
            ?.toString()
            .split("_")
            .join(" ");
        }
      } else {
        var parsingLabel =
          field.browseLabel && field.browseLabel.length
            ? field.browseLabel
            : field.displayLabel;
        try {
          resultadoOutput =
            parsingLabel.split(".").reduce((o: any, i: any) => o[i], row) ??
            "Nenhum";
          if (typeof resultadoOutput === "number") {
            resultadoOutput = resultadoOutput.toString();
          }
        } catch (e) {
          if (value === null || value === undefined) {
            resultadoOutput = "Nenhum";
          } else {
            resultadoOutput = value ?? "#ERR [1] (" + value + ")";
          }
        }
      }
    } else if (field.type === "display") {
      if (field.display !== undefined) {
        try {
          resultadoOutput =
            field.display.split(".").reduce((o: any, i: any) => o[i], row) ??
            "#ERR";
        } catch (e: any) {
          try {
            if (row[field.display]) {
              resultadoOutput = (row[field.display] ?? "#ERR").toString();
            } else {
              resultadoOutput = field.display;
            }
          } catch (e: any) {
            resultadoOutput = e.message;
          }
        }

        if (
          typeof resultadoOutput === "string" &&
          typeof resultadoOutput.includes === "function" &&
          dayjs(resultadoOutput).isValid() &&
          resultadoOutput.includes(":") &&
          resultadoOutput.includes("T") &&
          (resultadoOutput.includes("Z") || resultadoOutput.includes("-")) &&
          !resultadoOutput.includes(" ")
        ) {
          resultadoOutput = dayjs(resultadoOutput).format("DD/MM/YYYY HH:mm");
        } else {
          try {
            if (row[field.display] !== null) {

            } else {
              resultadoOutput = row[field.display].toString();
            }

          } catch (e: any) {
            resultadoOutput = e.message;
          }
        }
      }
    } else if (field.type === "richtextbox") {
      value = value?.replace(/<\/?[^>]+(>|$)/g, "");

      if (value !== null && value !== undefined) {
        value = value.includes("&NBSP")
          ? value.split("&NBSP;").join("")
          : value;
      }
      resultadoOutput = value;
    } else if (field.type === "custom") {
      if (field.name.includes("fk") && field.api) {
        if (value) {
          var parsingLabel =
            field.browseLabel && field.browseLabel.length
              ? field.browseLabel
              : field.displayLabel;
          try {
            resultadoOutput =
              parsingLabel.split(".").reduce((o: any, i: any) => o[i], row) ??
              "Nenhum";
            if (typeof resultadoOutput === "number") {
              resultadoOutput = resultadoOutput.toString();
            }
          } catch (e) {
            if (value === null || value === undefined) {
              resultadoOutput = "Nenhum";
            } else {
              resultadoOutput = value ?? "#ERR [1] (" + value + ")";
            }
          }
        }
      }
    } else if (field.type === "datepicker") {
      if (value) {
        resultadoOutput = dayjs(value).format("DD/MM/YYYY");
      } else {
        resultadoOutput = "Nenhum";
      }
    } else if (field.name === "question_registration_item_value_min") {
      if (row["question_registration_item_optional"] && value === 0) {
        resultadoOutput = '-';
      } else {
        resultadoOutput = value.toString();
      }

    } else if (field.name === "question_registration_item_value_max") {
      if (row["question_registration_item_optional"] && value === 0) {
        resultadoOutput = '-';
      } else {

        resultadoOutput = value.toString();
      }

    } else if (field.type === "numeric") {
      if (field.preffix === "R$") {
        var newValue = parseFloat(value?.toString() ?? "0").toLocaleString(
          "pt-BR",
          { minimumFractionDigits: 2 }
        );

        resultadoOutput = field.display = field.preffix + ` ` + newValue;
      } else {
        resultadoOutput = value?.toString() ?? "Nenhum";
      }
    } else {
      resultadoOutput = value ?? "Nenhum";

      if (
        resultadoOutput &&
        typeof resultadoOutput === "string" &&
        typeof resultadoOutput.includes === "function" &&
        dayjs(resultadoOutput).isValid() &&
        resultadoOutput.includes(":") &&
        (resultadoOutput.includes("Z") || resultadoOutput.includes("-")) &&
        resultadoOutput.includes("T") &&
        !resultadoOutput.includes(" ")
      ) {
        if (field.name === "filled_checklist_created_at") {
          resultadoOutput = dayjs(resultadoOutput).format("DD/MM/YYYY");
        } else {
          resultadoOutput = dayjs(resultadoOutput).format("DD/MM/YYYY HH:mm");
        }
      }
    }

    if (resultadoOutput === null && (value === null || value === undefined)) {
      resultadoOutput = "Nenhum";
    }
    if (typeof resultadoOutput === "string") {
      resultadoOutput = resultadoOutput
        .replace(/<\/?[^>]+(>|$)/g, "")
        .split("R$R$")
        .join("R$");

      if (resultadoOutput.includes("R$ ")) {
        resultadoOutput = resultadoOutput
          .replace(/<\/?[^>]+(>|$)/g, "")
          .split("R$")
          .join("");
      }
    }
    var output =
      typeof resultadoOutput === "string" || typeof resultadoOutput === "object"
        ? resultadoOutput
        : "";
    if (field.preffix) {
      output = field.preffix + output;
    }
    if (field.suffix) {
      output = value ?? "0";

      output += field.suffix;
    }
    if (field.mask && field.mask?.length > 0 && value && value.length > 0) {
      output = mask.default.format(value, { mask: field.mask });
    }
    try {
      if (html) {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        if (params.searchAll && typeof output === "string") {
          const text = params.searchAll.toLocaleUpperCase();
          const htmlfiedOutput = output
            .split(text)
            .map((item: any, index: any) => {
              if (index < output.split(text).length - 1) {
                return (
                  <>
                    {item}
                    <span className="highlight">{text}</span>
                  </>
                );
              }
              return item;
            });
          return htmlfiedOutput;
        }
      }

      return output;
    } catch (e: any) {
      return e.message;
    }
  };

  render() {
    return SchemaToParsedCell.parseFieldToValue(
      this.props.field,
      this.props.row
    );
  }
}
